import React from "react";

const SupportButton = ({ label = "☕ Buy Me a Coffee" }) => {
  return (
    <a
      href="https://www.buymeacoffee.com/democraticchess"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: "inline-block",
        padding: "10px 20px",
        backgroundColor: "#FFDD00",
        color: "#000",
        fontWeight: "bold",
        borderRadius: "8px",
        textDecoration: "none",
        fontSize: "16px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.15)",
        transition: "background-color 0.3s ease",
        margin: "8px auto",
        textAlign: "center"
      }}
      onMouseEnter={(e) => e.target.style.backgroundColor = "#ffd900cc"}
      onMouseLeave={(e) => e.target.style.backgroundColor = "#FFDD00"}
    >
      {label}
    </a>
  );
};

export default SupportButton;
